import { MLHelper } from '@bimser/core';
import { Transfer } from 'antd';
import classNames from 'classnames/bind';
import Styles from './assets/transferStyles.scss';
import { ITransferProps, TransferItem } from './entities';

const cx = classNames.bind(Styles);

const BCTransfer = (props: ITransferProps) => {
	const filterOption = (val: string, opt: TransferItem) => {
		return opt.title
			.toLocaleUpperCase(MLHelper.currentLanguage.culture)
			.includes(val.toLocaleUpperCase(MLHelper.currentLanguage.culture));
	};

	const transferClassnames = cx({
		readOnlyCursor: props.readOnly,
		[props.className]: !!props.className
	});

	return (
		<Transfer
			dataSource={props.dataSource}
			onChange={props.onChange}
			onSelectChange={props.onSelectChange}
			selectedKeys={props.selectedKeys}
			targetKeys={props.targetKeys}
			operations={props.operations}
			titles={props.titles}
			render={props.render}
			showSearch={props.showSearch}
			disabled={props.disabled || props.readOnly}
			showSelectAll={props.showSelectAll}
			style={props.style}
			className={transferClassnames}
			filterOption={filterOption}
			onSearch={props.onSearchChange}
		/>
	);
};
export default BCTransfer;
export { ITransferProps, TransferItem };
